import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography, Button } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { cores } from '../styles/styleUtils';
import { ICONE_POR_TIPO, ICONE_PADRAO } from './tiposAtividade';

// Painel de Atividades no novo padrão (cartões com ícone por tipo) usado
// tanto no fluxo de Lead (EditPropostaLeads.js) quanto nos demais fluxos
// (EditFluxo.js — Comercial/Engenharia/Montagem). Atividades antigas
// (só `{ data, msg }`, sem `tipo` estruturado) continuam aparecendo,
// só que com o ícone padrão e o texto corrido de `msg` — sem tentar
// reclassificar retroativamente o histórico.
const AtividadesPainel = ({
  atividades = [],
  onAdd,
  filterFn,
  height = '55vh',
  extraTop = null,
  disabled = false,
}) => {
  const lista = filterFn ? atividades.filter(filterFn) : atividades;
  const listaOrdenada = [...lista].reverse(); // mais recente primeiro

  return (
    <Stack sx={{ width: '100%', gap: 1.5 }}>
      <Button
        variant="contained"
        startIcon={<AddCircleOutlineIcon />}
        onClick={onAdd}
        disabled={disabled}
        sx={{
          alignSelf: 'center',
          textTransform: 'none',
          fontWeight: 'bold',
          borderRadius: 5,
          backgroundColor: cores.laranja,
          '&:hover': { backgroundColor: cores.laranjaEscuro },
        }}
      >
        Adicionar Atividade
      </Button>

      <Stack sx={{ height, overflowY: 'auto', gap: 1, width: '100%', p: 0.5 }}>
        {extraTop}
        {listaOrdenada.map((atividade, index) => {
          const Icone = (atividade.tipo && ICONE_POR_TIPO[atividade.tipo]) || ICONE_PADRAO;
          const nomeUsuario =
            (typeof atividade.usuario === 'object' ? atividade.usuario?.nome : atividade.usuario) ||
            (atividade.tipo ? null : 'Sistema');

          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                gap: 1.5,
                alignItems: 'flex-start',
                backgroundColor: cores.branco,
                borderRadius: 2,
                p: 1.25,
                border: `1px solid ${cores.borda}`,
              }}
            >
              <Icone sx={{ color: cores.laranja, mt: 0.3, flexShrink: 0 }} />
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography variant="caption" sx={{ color: cores.cinzaMedio }}>
                  {new Date(atividade.data).toLocaleDateString('pt-BR')}
                  {atividade.tipo ? ` • ${atividade.tipo}` : ''}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}
                >
                  {(atividade.descricao || atividade.msg || '').split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </Typography>
                {nomeUsuario && (
                  <Typography variant="caption" sx={{ color: cores.cinzaMedio }}>
                    {nomeUsuario}
                  </Typography>
                )}
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Stack>
  );
};

AtividadesPainel.propTypes = {
  atividades: PropTypes.array,
  onAdd: PropTypes.func,
  filterFn: PropTypes.func,
  height: PropTypes.string,
  extraTop: PropTypes.node,
  disabled: PropTypes.bool,
};

export default AtividadesPainel;